import { useState, useEffect } from 'react';

import { getCountryCode, getLocale } from '../config/globalStates';
import {
  COMMUNITY_GUIDELINES_MC,
  COMMUNITY_GUIDELINES_SEEK,
  COMMUNITY_GUIDELINES_ID,
  COMMUNITY_GUIDELINES_TH,
  COMMUNITY_GUIDELINES_ZH,
} from '../domain/constants';

export const useCommunityGuidelines = (): string => {
  const [guidelinesLink, setGuidelinesLink] = useState('');

  useEffect(() => {
    const countryCode = getCountryCode();
    const localeCode = getLocale();
    const appLinksMapper: Record<string, string> = {
      MY: COMMUNITY_GUIDELINES_MC,
      PH: COMMUNITY_GUIDELINES_MC,
      SG: COMMUNITY_GUIDELINES_MC,
      AU: COMMUNITY_GUIDELINES_SEEK,
      NZ: COMMUNITY_GUIDELINES_SEEK,
      ID:
        localeCode === 'en-ID'
          ? COMMUNITY_GUIDELINES_MC
          : COMMUNITY_GUIDELINES_ID,
      HK:
        localeCode === 'en-HK'
          ? COMMUNITY_GUIDELINES_SEEK
          : COMMUNITY_GUIDELINES_ZH,
      TH:
        localeCode === 'en-TH'
          ? COMMUNITY_GUIDELINES_SEEK
          : COMMUNITY_GUIDELINES_TH,
    };

    setGuidelinesLink(appLinksMapper[countryCode] || '');
  }, []);

  return guidelinesLink;
};
